import {
  Typography, Box,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../language/keys';
import { addDays } from '../../AccountsPage/formik';
import { DateRangeSelector } from '../DateItem';
import { PRICE_PLAIN_TYPE } from '../../../consts/enums';
import { PERMISSIONS } from '../../../consts/permissions';
import { useAuth } from '../../../hooks/useAuth';
import { DateValidationFields } from '../../../@types/Account';
import { AccountBillingTypeSelector } from './AccountBillingTypeSelector';
import { AccountPaidPlanSelector } from './AccountPaidPlanSelector';
import { style } from './style';
import { PaymentLinksSection } from './PaymentLinksSection';

type AccountPaidPlanProps = {
  accountId: string,
  pricePlan: string,
  isEditable: boolean,
  viewMode: ViewMode,
  startDatePaidPlan: DateValidationFields,
  endDatePaidPlan: DateValidationFields,
  billing: string,
  onValuesChange: (name: string, value: string) => void,
  onChangeDateField: (name: string, date: Date | string) => void,
  onChangePaidPlanStartDate: (name: string, date: Date | string) => void,
}
export const AccountPaidPlan = ({
  accountId,
  pricePlan,
  isEditable,
  viewMode,
  startDatePaidPlan,
  endDatePaidPlan,
  billing,
  onValuesChange,
  onChangeDateField,
  onChangePaidPlanStartDate,
}:AccountPaidPlanProps):JSX.Element => {
  const { t: translate } = useTranslation();
  const minEndDate = addDays(startDatePaidPlan.value, 1);
  const { hasPermissions } = useAuth();

  return (
    <Box>
      <Typography variant="h6" sx={ style.Typography.sx }>
        {translate(STRING_KEYS.PAID_PLAN)}
      </Typography>
      {(hasPermissions([PERMISSIONS.ACCOUNT_PAYMENT_LINK])) && (
        <PaymentLinksSection
          accountId={ accountId }
        />
      )}
      <AccountPaidPlanSelector
        viewMode={ viewMode }
        pricePlan={ pricePlan }
        onValuesChange={ onValuesChange }
        isEditable={ isEditable }
      />
      { (pricePlan !== PRICE_PLAIN_TYPE.Lite && pricePlan !== PRICE_PLAIN_TYPE.Trial && pricePlan !== PRICE_PLAIN_TYPE.PayPerInterview) && (
        <AccountBillingTypeSelector
          viewMode={ viewMode }
          billing={ billing }
          onValuesChange={ onValuesChange }
          isEditable={ isEditable }
        />
      ) }
      { (pricePlan !== PRICE_PLAIN_TYPE.Lite && pricePlan !== PRICE_PLAIN_TYPE.PayPerInterview) && (
        <DateRangeSelector
          startDate={ startDatePaidPlan }
          endDate={ endDatePaidPlan }
          viewMode={ viewMode }
          nameStartDate="startDatePaidPlan"
          nameEndDate="endDatePaidPlan"
          onChangeStartDate={ onChangePaidPlanStartDate }
          onChangeEndDate={ onChangeDateField }
          minEndDate={ minEndDate }
        />
      )}
    </Box>
  );
};
